import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Header, Item } from 'semantic-ui-react';
import moment from 'moment';

import './FeaturedBlogPost.css';
import { GatsbyImagePropType } from '../../../../services/proptypes';
import Image from '../../../../atoms/Image';
import ObjectUtils from '../../../../utils/ObjectUtils';

export default class FeaturedBlogPost extends React.PureComponent {
  render() {
    const { heroImage, summary, publishedAt, title, slug } = this.props;

    return (
      <React.Fragment>
        <Header as="h2">Featured Post</Header>
        <Link to={`/${slug}/`}>
          <Item.Group>
            <Item className="featured-blog-post">
              <Image src={heroImage} imageQuery={heroImage} />
              <Item.Content>
                <Item.Header>{title}</Item.Header>
                {ObjectUtils.isRenderable(publishedAt) && (
                  <Item.Meta>{moment(publishedAt).format('LL')}</Item.Meta>
                )}
                <Item.Description>{summary}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Link>
      </React.Fragment>
    );
  }
}

FeaturedBlogPost.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  publishedAt: PropTypes.string,
  heroImage: PropTypes.oneOf(
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(GatsbyImagePropType),
  ),
  slug: PropTypes.string.isRequired,
};

FeaturedBlogPost.defaultProps = {
  heroImage: null,
  publishedAt: null,
};
